import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

const RolesList = () => import(/* webpackChunkName: "roles" */ '@/views/Roles/List.vue');
const RoleEdit = () => import(/* webpackChunkName: "roles" */ '@/views/Roles/Edit.vue');
const RoleCreate = () => import(/* webpackChunkName: "roles" */ '@/views/Roles/Create.vue');

let rolesPages = {
  path: '/roles',
  redirect: '/roles',
  component: DashboardLayout,
  name: 'Roles',
  meta: {
    title: 'Roles Usuarios',
    auth: true,
  },
  children: [
    {
      path: '',
      name: 'RolesList',
      meta: {
        title: 'Listado',
        auth: ['roles.index'],
      },
      component: RolesList,
    },
    {
      path: ':id/edit',
      name: 'RoleEdit',
      meta: {
        title: 'Editar',
        auth: ['roles.update'],
      },
      component: RoleEdit,
    },
    {
      path: '/create',
      name: 'RoleCreate',
      meta: {
        title: 'Nuevo',
        auth: ['roles.store'],
      },
      component: RoleCreate,
    },
  ],
};

export default rolesPages;
